import Website from '../../assets/service/landing-page.png'
import MobileApplication from '../../assets/service/online-order.png'
import Ecommerce from '../../assets/service/ecommerce.png'
import Custom from '../../assets/service/backend.png'
import website from '../../assets/service/website.jpg'
import websitefull from '../../assets/service/websitefull.jpg'
import ecommercewraper from '../../assets/service/ecommercewraper.jpg'
import ecommercefull from '../../assets/service/ecommercefull.jpg'
import mobilewraper from '../../assets/service/mobilewraper.jpg'
import mobilefull from '../../assets/service/mobileapp2.jpg'
import customwraper from '../../assets/service/customewraper.jpg'
import customfull from '../../assets/service/customfull.jpg'
// const parallaxItems = [
//   {
//     img: 'https://media.geeksforgeeks.org/wp-content/cdn-uploads/20230202143636/NEXT-js-tutorial-1.png',
//     caption: 'Web Development',
//   },
//   {
//     img: 'https://media.geeksforgeeks.org/wp-content/cdn-uploads/20230202143636/NEXT-js-tutorial-1.png',
//     caption: 'E-commerce Solutions',
//   },
//   {
//     img: 'https://media.geeksforgeeks.org/wp-content/cdn-uploads/20230202143636/NEXT-js-tutorial-1.png',
//     caption: 'Mobile Apps',
//   },
// ];

const services =()=>{
    return(
        <>
            <div className="container-fluid" style={{background: "linear-gradient(to right, #3e13c0ff ,  #426fecff)"}}>
                <div className="container servicesContent" style={{padding:'50px'}}>
                    <p style={{color:'#ffffff'}}>SERVICES</p>
                    <h2 style={{color:'#ffffff', fontWeight:'500', fontFamily:'Bungee, sans-serif'}}>Need Amazing Business ?</h2>
                    
                    <div className='servicecontainer d-flex justify-content-center' style={{gap:'10px'}}>
                        <div className='servicetab'>
                            <div className='wraper'>
                                <img src={website} alt="website development" className='img-fluid' style={{width:'100%',height:'400px', borderRadius:'20px'}}/>
                                <p>Website Development</p>
                            </div>
                            <div className='content'>
                                <div className='row'>
                                    <div className='col-md-6 p-3'>
                                        <h5 className='mt-3' style={{color:'black', fontFamily:'Bungee, sans-serif', color:'#3e13c0ff'}}>Website Development</h5>
                                        <p style={{fontSize:'14px'}}>Website development involves building responsive, user-friendly, and visually stunning websites that adapt across all devices. It ensures fast loading, SEO-friendly structure, and strong security for reliability. With expandable features, businesses can scale their site as they grow, while smooth navigation and integrated forms improve user engagement. A powerful content management system (CMS) makes updating content simple, keeping the website fresh and effective in establishing a strong online presence.</p>
                                    </div>
                                    <div className='col-md-6'>
                                    <img src={websitefull} alt="website development" className='img-fluid' style={{width:'100%',height:'400px',borderRadius:'20px'}}/>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='servicetab'>
                            <div className='wraper'>
                                <img src={ecommercewraper} alt="website development" className='img-fluid' style={{width:'100%',height:'400px', borderRadius:'20px'}}/>
                                <p>Ecommerce Development</p>
                            </div>
                            <div className='content'>
                                <div className='row'>
                                    <div className='col-md-6 p-3'>
                                        <h5 className='mt-3' style={{color:'black', fontFamily:'Bungee, sans-serif', color:'#3e13c0ff'}}>Ecommerce Development</h5>
                                        <p style={{fontSize:'14px'}}>E-commerce development focuses on creating secure, scalable, and user-friendly online stores that deliver a smooth shopping experience across all devices. It includes stunning product displays, fast checkout, and multiple payment gateway integrations for convenience. With SEO-friendly structure, inventory management, and order tracking, businesses can efficiently manage operations while boosting sales. Expandable features ensure the store grows with your business, while strong security and responsive design build customer trust.</p>
                                    </div>
                                    <div className='col-md-6'>
                                    <img src={ecommercefull} alt="website development" className='img-fluid' style={{width:'100%',height:'400px',borderRadius:'20px'}}/>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='servicetab'>
                            <div className='wraper'>
                                <img src={mobilewraper} alt="website development" className='img-fluid' style={{width:'100%',height:'400px', borderRadius:'20px'}}/>
                                <p>Android/iOS App</p>
                            </div>
                            <div className='content'>
                                <div className='row'>
                                    <div className='col-md-6 p-3'>
                                        <h5 className='mt-3' style={{color:'black', fontFamily:'Bungee, sans-serif', color:'#3e13c0ff'}}>Android/iOS App</h5>
                                        <p style={{fontSize:'14px'}}>Android and iOS app development delivers high-performing, user-friendly, and scalable mobile applications tailored to your business needs. It includes intuitive UI/UX design, smooth navigation, and fast performance to enhance user engagement. With features like push notifications, API integrations, and secure payment systems, apps are built to improve customer experience and business efficiency. Responsive, secure, and easily expandable, these apps ensure seamless functionality across device.</p>
                                    </div>
                                    <div className='col-md-6'>
                                    <img src={mobilefull} alt="website development" className='img-fluid' style={{width:'100%',height:'400px',borderRadius:'20px'}}/>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='servicetab'>
                            <div className='wraper'>
                                <img src={customwraper} alt="website development" className='img-fluid' style={{width:'100%',height:'400px', borderRadius:'20px'}}/>
                                <p>Custom Development</p>
                            </div>
                            <div className='content'>
                                <div className='row'>
                                    <div className='col-md-6 p-3'>
                                        <h5 className='mt-3' style={{color:'black', fontFamily:'Bungee, sans-serif', color:'#3e13c0ff'}}>Custom Development</h5>
                                        <p style={{fontSize:'14px'}}>Custom development offers tailored solutions for web, Android, and portal applications to meet specific business needs. It focuses on building scalable, secure, and high-performing platforms with modern designs and user-friendly interfaces. From custom websites to mobile apps and enterprise portals, every solution is crafted to deliver seamless functionality, smooth navigation, and future-ready expandability. With integration of advanced features, APIs, and robust security.</p>
                                    </div>
                                    <div className='col-md-6'>
                                    <img src={customfull} alt="website development" className='img-fluid' style={{width:'100%',height:'400px',borderRadius:'20px'}}/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                </div>
            </div>
        </>
    )
}
export default services